import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "dropzone-drop-indicator"
};
const _hoisted_2 = {
    key: 0,
    class: "icon-file-upload text-primary icon-3x"
};
const _hoisted_3 = {
    key: 1,
    class: "dropzone-placeholder"
};
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { amplitudeService } from '@/models/amplitude-service';
export default /*@__PURE__*/ _defineComponent({
    __name: 'dropzone',
    props: {
        empty: { type: Boolean, default: false },
        showIndicator: { type: Boolean, default: true }
    },
    emits: ['drop'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const route = useRoute();
        const props = __props;
        const state = ref('idle');
        function fileDragEnter(event) {
            event.preventDefault();
            event.stopPropagation();
            if (!event.dataTransfer || !event.dataTransfer.items || !event.dataTransfer.items.length) {
                return;
            }
            for (const item of event.dataTransfer.items) {
                if (item.kind !== 'file') {
                    return;
                }
            }
            state.value = 'over';
        }
        function fileDragOver(event) {
            event.preventDefault();
            event.stopPropagation();
        }
        function fileDragLeave(event) {
            event.preventDefault();
            event.stopPropagation();
            state.value = 'idle';
        }
        function fileDrop(event) {
            var _a;
            event.preventDefault();
            event.stopPropagation();
            if (!event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files.length) {
                return;
            }
            const validFiles = [];
            for (const file of event.dataTransfer.files) {
                if (file.size <= 0) {
                    continue;
                }
                // Folder
                if (file.size % 4096 === 0 && file.name === '.') {
                    continue;
                }
                validFiles.push(file);
            }
            if (validFiles.length) {
                amplitudeService.trackEvent('[Frontend] User Uploaded File', { method: 'drag_and_drop', page: (_a = route.name) === null || _a === void 0 ? void 0 : _a.toString() });
                emit('drop', validFiles);
            }
            state.value = 'idle';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{ 'dropzone--over': state.value === 'over' }, "dropzone"]),
                onDragenter: fileDragEnter,
                onDragleave: fileDragLeave,
                onDragover: fileDragOver,
                onDrop: fileDrop
            }, [
                (state.value === 'over')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (__props.showIndicator)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (props.empty)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                            _createElementVNode("i", { class: "icon-files-empty icon-3x" }, null, -1)
                        ]))]))
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
            ], 34));
        };
    }
});
